/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$('.AnnouncementBar__Wrapper.slider').flickity({
  // options
  wrapAround: true,
  autoPlay: true,
  autoPlay: 4500,
  prevNextButtons: false,
  pageDots: false,
  percentPosition: false
});



$('.quickshop-button, .quickshop-button-small').click(function(e){ 
  e.preventDefault();
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('1 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});

$(document).on('click', '.quickshop-button', function(e) {
  
  e.preventDefault();
  
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('2 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});

$('body').on('click', '.quickshop-button-small', function(e) {
  e.preventDefault();
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('3 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});



$(document).ready(function() {
  $('.ProductItem__ImageWrapper--withAlternateImage').on('touchstart touchend', function(e) {
//     e.preventDefault();
    $(this).find('.ProductItem__Image:not(.ProductItem__Image--alternate)').toggleClass('hover_effect');
    $(this).find('.ProductItem__Image--alternate').toggleClass('hover_effect');
    console.log('alternate');
  });
  
  $('.has-megamenu').click(function(e){ 
    e.preventDefault();
  });
});


(() => {
    /**
     *
     * @param {string} selector
     * @returns {Promise<HTMLDivElement>}
     */
    function waitForElm(selector) {
        console.log('waiting for elem ' + selector);
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver((mutations) => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    }

    waitForElm('button[name="checkout"]').then((el) => {
        if (!document.body.classList.contains('cleever-on')) {
            return
        }
        el.addEventListener('click', window.cleeverCheckouthandleClick)
        const new_element = el.cloneNode(true);
        new_element.addEventListener('click', window.cleeverCheckouthandleClick)
        el.parentNode.replaceChild(new_element, el);
        let i = 0;
        let interval = setInterval(() => {
            i++
            const el = document.querySelector('button[name="checkout"]')
            console.log('set interval running')
            const new_element = el.cloneNode(true);
            el.parentNode.replaceChild(new_element, el);

            new_element.addEventListener('click', window.cleeverCheckouthandleClick)
            if (i == 5) {
                clearInterval(interval)
            }
        }, 2000)


        
    })
    
    waitForElm(".rebuy-cart__flyout-actions button").then((el) => {
        if (!document.body.classList.contains('cleever-on')) {
            return
        }
        const div = document.createElement('div');
        div.style.width = "100%";
        div.innerHTML = `
        <cleever-cta-discount style="padding: 14px;">
            <span class="cleever-visible-text" slot="text" style=" padding: 0 8px;font-size: 15px;">Get Free Shipping</span>
            ${el.outerHTML}
        </cleever-cta-discount>
        <div class="cleever-divider" style="height: 1px; background-color: #D6D6D6; width: 100%; margin: 20px 0 4px 0;"></div>
        <cleever-not-eligible-discount>

            <span class="cleever-visible-text" slot="text">NOT eligible for Free Shipping</span>
            <cleever-fake-additional-checkouts size="small"  paypal shop-pay google-pay apple-pay klarna></cleever-fake-additional-checkouts>
        </cleever-not-eligible-discount>`
        el.replaceWith(div)
        
        
        div.querySelector('button').addEventListener('click', window.cleeverCheckouthandleClick)
    })

    

    waitForElm('#rebuy-cart__progress-bar-meter-label').then((container) => {
        if (!document.body.classList.contains('cleever-on')) {
            return
        }
        const handleThreshold = () => {
            console.log('running threshold')
            const complete = container.textContent.toUpperCase().includes('CONGRATS');
            /**
             * @type {HTMLSpanElement[]}
             */
            const notEligibleElementTexts = document.querySelectorAll(
                'cleever-not-eligible-discount span'
            );
            console.log({ complete });
            
            for (const notEligibleElementText of notEligibleElementTexts) {
                notEligibleElementText.hidden = complete;
            }
        };
        handleThreshold();
        console.log('observing')
        console.log('container')
        const observer = new MutationObserver((mutations) => {
            handleThreshold();
        });

        observer.observe(container, {
            childList: true,
            subtree: true,
        });
    })
  
})();
